import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, HostBinding, Input, OnInit, Output } from '@angular/core';
import { BannerCellHeightEnum, Section, BannerOptions, BgPositionEnum, ContentElement, GridCell, SectionData, RowCell } from '../../models/sections-model';
import { BannerLayoutEnum } from '../../models/sections-model';
import { Subject } from 'rxjs';


@Component({
  selector: 'kve-banner-renderer',
  templateUrl: './banner-renderer.component.html',
  styleUrls: ['./banner-renderer.component.scss']
})
export class BannerRendererComponent implements OnInit,AfterViewInit {
  @Input() data:SectionData;
  @Input() edit:boolean;
  @Input() heading:string;
  @Input() title:string;
  selectedCell:GridCell;
  preview:boolean;
  headerText:string;
  footerText:string;
  //layoutClass:BannerLayoutEnum;
  //layoutClass = "layout-class-1";
  numberOfElements:number;
  bannerText:string;
  bannerCells:any[];

  imgSrc:string;
  bgImgSrc:string;

  fillClass:string;

  layoutClass:string;

  fillColor:string;
  fillColor1:string;
  fillColor2 = 'var(--color-primary-400)';

  noImageUrl = "https://placehold.co/1280x426?text=1280+X+427+No+Image";
  imgRightUrl = "https://placehold.co/1280x426?text=1280+X+427+Image+On+Right";
  imgLeftUrl = "https://placehold.co/1280x426?text=1280+X+427+Image+On+Left";

  @HostBinding("style.--background-image-position") bgPosition:string;
  @HostBinding("style.--banner-cell-height") cellHeight:string;
  
  hdrParBgColor:string;
  hdrContLayoutClass:string;
  heightCls:string;

  contentHeight:string;


  headerTxtClr:string;
  hdrFontFam:string;
  hdrContBgClr:string;

  hdrBorderColr:string;
  hdrPadCust:string;
  hdrFntSizeClass:string;
  hdrBorderWdtCls:string;
  hdrBorderRdsCls:string;
  hdrAlign:string;

  contentElements:ContentElement[];

  wrapperClass:string;
  

  @Output() editUpdate = new EventEmitter<any>();
  @Output() createUpdate = new EventEmitter<GridCell|RowCell>();

  //background: url("http://kwikstore-dev/assets/slide-images/output/1000/modern-slide-bnr2_2000x.jpg");
//background-image:url("http://kwikstore-dev/assets/slide-images/output/1000/modern-slide-bnr1_2000x.jpg");
  // constSvg = 'data:image/svg+xml;utf8,<svg id="visual" viewBox="0 0 960 270" width="960" height="270" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1"><rect x="0" y="0" width="960" height="270" fill="#70b4d7"></rect><path d="M0 187L22.8 190.7C45.7 194.3 91.3 201.7 137 201.5C182.7 201.3 228.3 193.7 274 197.2C319.7 200.7 365.3 215.3 411.2 220C457 224.7 503 219.3 548.8 216.7C594.7 214 640.3 214 686 214.5C731.7 215 777.3 216 823 212C868.7 208 914.3 199 937.2 194.5L960 190L960 271L937.2 271C914.3 271 868.7 271 823 271C777.3 271 731.7 271 686 271C640.3 271 594.7 271 548.8 271C503 271 457 271 411.2 271C365.3 271 319.7 271 274 271C228.3 271 182.7 271 137 271C91.3 271 45.7 271 22.8 271L0 271Z" fill="#c1d2ea" stroke-linecap="round" stroke-linejoin="miter"></path></svg>'
  
  constructor(private cdr: ChangeDetectorRef) { }
  ngAfterViewInit(): void {
    console.log(this.data);
    this.wrapperClass = this.data.wrapperClass?this.data.wrapperClass:"transparent";
    this.bgPosition = this.data.bgPosition?this.data.bgPosition:BgPositionEnum.TOP;
    this.cellHeight = this.data.cellHeight?this.data.cellHeight:BannerCellHeightEnum.THREE_TWENTY;

 
    this.numberOfElements = this.data.numberOfElements;
    this.bannerCells = this.data.bannerOptions.rowCells;
    this.preview = this.data.isPreview?this.data.isPreview:false;
    
    this.imgSrc = this.data.bannerOptions.rowCells[0].imgSrc;
    this.bgImgSrc = "url("+this.imgSrc+")";
    this.selectedCell = this.data.bannerOptions.rowCells[0];
    console.log(this.selectedCell,this.bgImgSrc);
    this.contentHeight = this.selectedCell.contentHeight?this.selectedCell.contentHeight:"auto";
    this.contentElements = this.selectedCell.contentElements

    /* let heading = this.selectedCell.heading;
    if(heading != undefined){
      this.headerText = heading.headerText?heading.headerText:"You haven't suppllies Header Text";
    } */
    this.bannerText = this.selectedCell.bannerText?this.selectedCell.bannerText:"Supply Fucking Banner Text Boy";
    //this.footerText = this.selectedCell.footer.footerText;
    this.layoutClass = this.selectedCell.layoutClass?this.selectedCell.layoutClass:"layout-class-1";
    this.fillClass = this.selectedCell.fillClass?this.selectedCell.fillClass:"";
    this.heightCls = this.selectedCell.heightCls?this.selectedCell.heightCls:this.setHeightClass();
    this.fillColor = this.selectedCell.fillColor;
    this.fillColor1 = this.selectedCell.fillColor?this.selectedCell.fillColor:"var(--color-primary-200)";

    //headerStuff
    /* this.headerTxtClr = this.selectedCell.heading.headerTxtClr;
    this.hdrFontFam = this.selectedCell.heading.hdrFontFam;
    this.hdrContBgClr = this.selectedCell.heading.hdrContBgClr;
    this.hdrBorderColr = this.selectedCell.heading.hdrBorderColr;
    this.hdrPadCust = this.selectedCell.heading.hdrPadCust;
    this.hdrFntSizeClass = this.selectedCell.heading.hdrFntSizeClass;
    this.hdrBorderWdtCls = this.selectedCell.heading.hdrBorderWdtCls;
    this.hdrBorderRdsCls = this.selectedCell.heading.hdrBorderRdsCls;
    this.hdrAlign = this.selectedCell.heading.hdrAlign; */
  }

  ngOnInit(): void {
    
  }

  onUpdateContent(contentElement:ContentElement){
    console.log(contentElement);
    this.editUpdate.emit(contentElement)
  }

  setHeightClass(){
    let heightCls = "";
    if(this.cellHeight != undefined){
      if(this.cellHeight == BannerCellHeightEnum.THREE_TWENTY || BannerCellHeightEnum.FOUR_TWENTY || BannerCellHeightEnum.FIVE_FOURTY){
        switch (this.cellHeight) {
          case BannerCellHeightEnum.THREE_TWENTY:
            heightCls = "banner-small";
            break;
          case BannerCellHeightEnum.FOUR_TWENTY:
            heightCls = "banner-medium";
            break;
          case BannerCellHeightEnum.FIVE_FOURTY:
            heightCls = "banner-large";
            break;
        
          default:
            break;
        }
      }else{
        heightCls = "banner-custom"
      }
    }
    return heightCls;
  }

  createContent(cell:GridCell|RowCell){
    console.log(cell)
    this.createUpdate.emit(cell);
  }

  updateSection(section:Section){
    this.data = section;
    this.selectedCell = section.sectionData.bannerOptions.rowCells[0];
    this.imgSrc = section.sectionData.bannerOptions.rowCells[0].imgSrc;
    this.bgImgSrc = "url("+this.imgSrc+")";
    console.log(this.selectedCell,this.bgImgSrc,this.edit);
    this.cdr.detectChanges();
  }

}
